// src/components/RandomQuote.js
import React, { useEffect, useState } from 'react';
import { Quotations } from '../data/Quotations'; // We'll put your list here!

const RandomQuote = () => {
  const [quote, setQuote] = useState(null);

  useEffect(() => {
    const randomIndex = Math.floor(Math.random() * Quotations.length);
    setQuote(Quotations[randomIndex]);
  }, []);

  if (!quote) return null;

  return (
    <div className="random-quote">
      <p className="quote-text">"{quote.text}"</p>
      <p className="quote-author">— {quote.author}</p>
    </div>
  );
};

export default RandomQuote;
